import React, { Component } from "react";
import PropTypes from "prop-types";
import cn from "classnames";

class EditableInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editMode: props.editMode || false,
      targetValue: props.value
    };
  }

  handleChange = e => {
    const { onChange, name } = this.props;
    const { targetValue } = this.state;
    onChange(name, targetValue);
  };

  triggerEditMode = editMode => {
    if (this.props.editMode) {
      return;
    }

    this.setState({
      editMode
    });
  };

  render() {
    const { name, type, disabled, value } = this.props;
    const attrs = {
      name,
      type
    };

    if (disabled) {
      attrs.disabled = true;
    }
    return (
      <div
        className="editableInput"
        onClick={this.triggerEditMode.bind(this, true)}
        onBlur={this.triggerEditMode.bind(this, false)}
        onFocus={e => {
          e.stopPropagation();
        }}
      >
        <span
          className={cn("editableInput__label", {
            hidden: this.state.editMode,
			"red-color": this.props.redTitle
          })}
        >
          {this.state.targetValue}
        </span>
        <input
          className={cn("editableInput__node", {
            hidden: !this.state.editMode
          })}
          {...attrs}
          onBlur={this.handleChange}
          onChange={e => this.setState({ targetValue: e.target.value })}
          value={this.state.targetValue || ""}
        />
      </div>
    );
  }
}

EditableInput.propTypes = {
  editMode: PropTypes.bool,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string
};

export default EditableInput;



// WEBPACK FOOTER //
// ./components/ClientForm/EditableInput.js